import { isTicketsModuleEnabled } from "@/modules/settings/queries/tenantSettingsSelectors";

const Tickets = () => import("./views/Tickets.vue");
const roles = isTicketsModuleEnabled.value
  ? ["ROLE_TICKET_ADMIN", "ROLE_PARENT", "ROLE_INSTITUTION_WORKER", "ROLE_INSTITUTIONS_ADMIN"]
  : [];

export default [
  {
    path: "/tickets",

    name: "tickets.list",
    component: Tickets,

    meta: {
      roles: roles,
    },
  },
];
